import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed, onMounted, PropType, ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import { BaseSelect } from '@/lib/components/Select';
import { IErrors, IOption } from '@/lib';
import { FilterTag, Organisation, TagGroupName } from '@/models';
import { FilterTagService } from '@/services/api/filter-tag.service';
import axios from 'axios';
import { capitalize } from '@/lib/helpers/string.helper';


export default /*#__PURE__*/_defineComponent({
  __name: 'CommunityTeamSelect',
  props: {
  organisationalUnit: {
    type: String as PropType<Organisation['id']>,
    default: ''
  },
  communityTeam: {
    type: String as PropType<FilterTag['id']>,
    default: ''
  },
  errors: {
    type: String,
    default: ''
  }
},
  emits: ["update:community-team"],
  setup(__props, { emit: __emit }) {

const { t } = useI18n();
const props = __props;
const emit = __emit;

const communityTeams = ref<Array<FilterTag>>([]);
const fetchErrors = ref<IErrors | null>(null);
const tagService = new FilterTagService();

const validationErrors = computed<string | null>(() => props.errors || fetchErrors.value?.message?.[0] || null);
const communityTeamLabel = computed<string>(() => capitalize(t('custom.uhb.copd.community-team')));
const communityTeamPlaceholder = computed<string>(() => capitalize(
  t(
    'custom.uhb.copd.select-entity',
    [t('custom.uhb.copd.community-team')]
  )
));
const communityTeamOptions = computed<Array<IOption>>(() => communityTeams.value.map((team: FilterTag) => ({
  value: team.id,
  label: team.name
})));

watch(() => props.organisationalUnit, () => fetchCommunityTeams());
onMounted(() => {
  if (props.organisationalUnit) {
    fetchCommunityTeams();
  }
});
const updateCommunityTeam = (tagId: string) => {
  const tag = communityTeams.value.find((tag) => tag.id === tagId);
  if (tag) {
    emit('update:community-team', {
      id: tag.id,
      title: tag.name,
      attributes: {
        name: tag.name
      }
    });
  }
};
const fetchCommunityTeams = async () => {
  try {
    communityTeams.value = await tagService.getTagsForGroupName(TagGroupName.CommunityTeam, {
      params: {
        organisational_unit: props.organisationalUnit
      }
    });
  } catch (e) {
    if (!axios.isAxiosError(e)) {
      throw e;
    }
    if (e.response.status === 422) {
      fetchErrors.value = e.response.data?.errors;
    } else {
      fetchErrors.value = {};
    }
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(BaseSelect), {
    "data-dusk": "copd-program-community-team",
    "model-value": __props.communityTeam,
    label: communityTeamLabel.value,
    placeholder: communityTeamPlaceholder.value,
    options: communityTeamOptions.value,
    disabled: !__props.organisationalUnit,
    error: validationErrors.value,
    class: "w-full",
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (updateCommunityTeam($event as string)))
  }, null, 8, ["model-value", "label", "placeholder", "options", "disabled", "error"]))
}
}

})